import { useMemo } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { Box } from "@mui/material";
import "./product-carousel.css";

const FALLBACK_SVG =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400"><rect width="100%" height="100%" fill="#ffffff"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%23999" font-family="Arial" font-size="20">Imagen no disponible</text></svg>';

function CustomPaging({ images = [], customClass = "" }) {
  const safeImages = useMemo(() => {
    return Array.isArray(images) ? images : [];
  }, [images]);

  const settings = useMemo(() => ({
    customPaging: function (i) {
      const it = safeImages[i] || {};
      const src = it.src || FALLBACK_SVG;
      const alt = it.alt || `Miniatura ${i + 1}`;
      return (
          <img
            src={src}
            alt={alt}
            loading="lazy"
            onError={(e) => (e.currentTarget.src = FALLBACK_SVG)}
            className={`carousel-dot-image`}
          />
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
  }), [safeImages]);

  if (safeImages.length === 0) {
    return (
      <Box
        className={customClass}
        sx={{
          width: "100%",
          aspectRatio: "4/3",
          display: "grid",
          placeItems: "center",
          bgcolor: "#f7f7f7",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box component="span" sx={{ color: "text.secondary" }}>
          No hay imágenes para mostrar
        </Box>
      </Box>
    );
  }

  return (
    <Box className={`slider-container ${customClass}`}>
      <Slider {...settings}>
        {safeImages.map((image, index) => (
          <Box key={index}>
            <img
              src={image.src || FALLBACK_SVG}
              alt={image.alt || `Slide ${index + 1}`}
              loading="lazy"
              onError={(e) => (e.currentTarget.src = FALLBACK_SVG)}
              className="carousel-image"
              style={{ width: "70%", height: "auto", display: "block", userSelect: "none" }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
}

CustomPaging.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
  customClass: PropTypes.string,
};

export default CustomPaging;